import { Box, Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import axios from "../../../../services/auth/jwt/config";

const CheckItem = ({ item, formId, fieldId }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (formId) {
      getRemainingCount();
    }
  }, []);

  const getRemainingCount = () => {
    try {
      axios
        .post(`/formfilled/count/selection`, {
          form: formId,
          selectionId: item._id,
          formField: fieldId,
          userInput: item.title,
        })
        .then(({ data }) => {
          setCount(data.entries);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.msgFa);
          } else {
            console.log(error.message);
          }
        });
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <Box marginLeft={"20px"} display={"flex"} alignItems={"center"}>
      <FormControlLabel
        disabled
        control={<Checkbox name={item.title} />}
        label={item.title}
      />
      {item.limits?.count && formId && (
        <Typography color="textSecondary">
          (ظرفیت باقی مانده: {count})
        </Typography>
      )}
    </Box>
  );
};

export default CheckItem;
